var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTransferIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 39,
    height: 39,
    viewBox: "0 0 39 39",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_2814",
    "data-name": "Group 2814",
    transform: "translate(-366 -683)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_330",
    "data-name": "Ellipse 330",
    cx: 19.5,
    cy: 19.5,
    r: 19.5,
    transform: "translate(366 683)",
    fill: "#ebe5ff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "noun-bank-5506628",
    transform: "translate(299.424 661.738)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3509",
    "data-name": "Path 3509",
    d: "M101.658,48.564h2.123V41.87a3.035,3.035,0,0,1,6.07,0v6.694h3.781V41.871a3.026,3.026,0,0,1,.891-2.144l.036-.033a3.035,3.035,0,0,1,5.143,2.177v6.694h2.123V36.709H101.658V48.565Zm9.213-16.275a.573.573,0,1,1,0-1.145h1.741a.573.573,0,0,1,0,1.145Zm3.906,16.275h3.781V41.87a1.89,1.89,0,0,0-3.2-1.363l-.026.028a1.886,1.886,0,0,0-.556,1.334v6.694Zm-9.851,0h3.781V41.87a1.89,1.89,0,0,0-3.781,0ZM117.95,32.19l-6.21-4.2-11.2,7.576h22.394l-4.987-3.373Zm4.556,17.518H100.976a.97.97,0,0,0,0,1.941h21.531a.97.97,0,0,0,0-1.941Z",
    transform: "translate(-25.915)",
    fill: "#2f00ef"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTransferIcon);
export default __webpack_public_path__ + "static/media/transfer-icon.b46746bc5f5113dae0fa2ce424bcdfc5.svg";
export { ForwardRef as ReactComponent };